<div class="PGSlider {{scaledValueList != null ? 'PGSlider--HasScale' : ''}}">
    <div class="d-flex align-items-center">
        <div class="PGSlider-Inner">
            <input [id]="fieldId" class="form-control" type="range"
                [readonly]="readonly" [required]="required" [attr.min]="scaledMin" [attr.max]="scaledMax" [attr.step]="scaledStep"
                [ngModel]="getValue()" (ngModelChange)="setValue($event);"/>

                @if (scaledValueList != null) {
                    <div class="small text-muted PGSlider-Scale">
                        @for (item of scaledValueList; track item) {
                            <div class="border-start">
                                <div>{{item}}</div>
                            </div>
                        }
                    </div>
                }
            </div>
            <div class="ps-2 text-end" style="flex: 0; min-width: 2em;">{{value}}</div>
        </div>
    </div>